import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export const ScrollToTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="scroll-to-top-btn"
      aria-label="Scroll to top"
      className="fixed bottom-6 right-6 z-40 w-12 h-12 grid place-items-center bg-[#eb5381] hover:bg-[#d64570] text-white shadow-lg transition-colors"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
};
